class ProductCard487 extends HTMLElement {
  constructor() {
    super()
    this.hoverImg = null
    this.hoverImg2 = null
    this.leftZone = null
    this.rightZone = null
  }

  connectedCallback() {
    this.setupHoverEvents()
    this.updateCurrency()
    this.checkReviews()
    this.setupSizeBarEvents()
  }

  setupHoverEvents() {
    this.hoverImg = this.querySelector('.hover-image')
    this.hoverImg2 = this.querySelector('.hover-image-2')
    this.leftZone = this.querySelector('.hover-zone.left')
    this.rightZone = this.querySelector('.hover-zone.right')

    if (!this.hoverImg || !this.leftZone || !this.rightZone) return

    const showLeftImage = () => {
      this.hoverImg.style.opacity = '1'
      if (this.hoverImg2) this.hoverImg2.style.opacity = '0'
    }

    const showRightImage = () => {
      if (this.hoverImg2) {
        this.hoverImg.style.opacity = '0'
        this.hoverImg2.style.opacity = '1'
      } else {
        this.hoverImg.style.opacity = '1'
      }
    }

    const hideAll = () => {
      this.hoverImg.style.opacity = '0'
      if (this.hoverImg2) this.hoverImg2.style.opacity = '0'
    }

    this.leftZone.addEventListener('mouseenter', showLeftImage)
    this.rightZone.addEventListener('mouseenter', showRightImage)
    this.leftZone.addEventListener('mouseleave', hideAll)
    this.rightZone.addEventListener('mouseleave', hideAll)

    this.leftZone.addEventListener('touchstart', showLeftImage, { passive: true })
    this.rightZone.addEventListener('touchstart', showRightImage, { passive: true })

    this.leftZone.addEventListener('touchend', hideAll, { passive: true })
    this.rightZone.addEventListener('touchend', hideAll, { passive: true })
  }

  updateCurrency() {
    const currency = document.querySelector(".site-currency")?.innerText.trim();
    const el = this.querySelector('.prod-currency');
    const priceEl = this.querySelector('.prod-price .money');

    if(priceEl){
      let text = priceEl.innerText.replace(/\s[A-Z]{3}$/, '').trim();
      
      text = text.replace(/\s+/g, '');

      priceEl.innerText = `${text}`;
    }

    el.innerText = `${currency}`;
  }

  checkReviews() {

  }

  setupSizeBarEvents() {
    const sizeButtons = this.querySelectorAll(
      '.size-option.available[data-variant-id]:not([data-variant-id=""])'
    );

    sizeButtons.forEach(btn => {
      if (btn.dataset.listenerAttached === 'true') return;

      btn.dataset.listenerAttached = 'true';

      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (btn.classList.contains('loading')) return;

        btn.classList.add('loading');

        console.log('binding');

        const variantId = btn.dataset.variantId;

        if (!variantId) return;

        if (window.CartJS && CartJS.addItem) {
          // Reuse the same suppression class the cart-drawer line-items use so
          // this quick-add doesn't trigger the big center loader/dark overlay
          // (requestBodyClass:"loading" fires for every CartJS request).
          document.body.classList.add('cart-line-updating');

          CartJS.addItem(variantId, 1, {}, {
            success: function () {
              setTimeout(function () {
                document.body.classList.remove('loading', 'showOverly', 'cart-line-updating');
                document.querySelectorAll('.block-cart').forEach(function (el) {
                  el.classList.add('active');
                });
              }, 1000);
              btn.classList.remove('loading');
            },
            error: function (jqXHR) {
              document.body.classList.remove('cart-line-updating');
              btn.classList.remove('loading');
              var message = 'Something went wrong adding this to your cart.';
              try { message = JSON.parse(jqXHR.responseText).description || message; } catch (e) {}
              var box = document.querySelector('.error-message');
              var drawer = document.getElementById('errorDrawer');
              if (box) box.textContent = message;
              if (drawer) {
                document.body.classList.add('showOverly');
                drawer.style.display = 'block';
                setTimeout(function () {
                  document.body.classList.remove('showOverly');
                  drawer.style.display = 'none';
                }, 4000);
              }
            }
          });
        } else {
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              id: variantId,
              quantity: 1
            })
          })
          .then(res => res.json())
          .catch(err => console.error(err))
          .finally(() => {
            btn.classList.remove('loading');
          });
        }
      });
    });
  }
}

if (!customElements.get('product-card-487')) { 
  customElements.define('product-card-487', ProductCard487)
}


document.addEventListener("DOMContentLoaded", () => {
    const wrapper = document.querySelector(".collection-sort-487")
    const trigger = wrapper.querySelector(".sort-trigger")
    const currentSort = wrapper.dataset.currentSort

    // Set selected label text
    const currentOption = wrapper.querySelector(`[data-value="${currentSort}"]`)
    if (currentOption) {
      currentOption.classList.add("selected")
      trigger.innerHTML = currentOption.innerHTML
    }

    // Toggle dropdown
    trigger.addEventListener("click", () => {
      wrapper.classList.toggle("open")
    })

    // Close on outside click
    document.addEventListener("click", (e) => {
      if (!wrapper.contains(e.target)) {
        wrapper.classList.remove("open")
      }
    })
})